// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file role_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file role_type.proto.
 */
export const file_role_type: GenFile = /*@__PURE__*/
  fileDesc("Cg9yb2xlX3R5cGUucHJvdG8SBmRvbWFpbiqYAQoIUm9sZVR5cGUSFQoRUk9MRV9UWVBFX1VOS05PV04QABITCg9ST0xFX1RZUEVfQURNSU4QZRIVChFST0xFX1RZUEVfU0VSVklDRRBmEh0KGVJPTEVfVFlQRV9ERUxFR0FURURfQURNSU4QZxITCg5ST0xFX1RZUEVfVVNFUhDJARIVChBST0xFX1RZUEVfQ1VTVE9NEK0CQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * @generated from enum domain.RoleType
 */
export enum RoleType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: ROLE_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * special roles
   *
   * @generated from enum value: ROLE_TYPE_ADMIN = 101;
   */
  ADMIN = 101,

  /**
   * @generated from enum value: ROLE_TYPE_SERVICE = 102;
   */
  SERVICE = 102,

  /**
   * @generated from enum value: ROLE_TYPE_DELEGATED_ADMIN = 103;
   */
  DELEGATED_ADMIN = 103,

  /**
   * other default roles
   *
   * @generated from enum value: ROLE_TYPE_USER = 201;
   */
  USER = 201,

  /**
   * custom roles
   *
   * @generated from enum value: ROLE_TYPE_CUSTOM = 301;
   */
  CUSTOM = 301,
}

/**
 * Describes the enum domain.RoleType.
 */
export const RoleTypeSchema: GenEnum<RoleType> = /*@__PURE__*/
  enumDesc(file_role_type, 0);

